import { getAxiosClient } from "../../axios-client";
import { getAllSubcontractorRequestBody, getAllSubcontractorResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllSubcontractor = async (body: getAllSubcontractorRequestBody) => {
    return await axiosClient.ax.post<getAllSubcontractorResponse>("/Subcontractor/GetAll", body);
};
